/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetWellKnownEmailServices200ResponseInnerConfig
 */
export interface GetWellKnownEmailServices200ResponseInnerConfig {
    /**
     * 
     */
    host?: string;
    /**
     * 
     */
    port?: number;
    /**
     * 
     */
    secure?: boolean;
}

/**
 * Check if a given object implements the GetWellKnownEmailServices200ResponseInnerConfig interface.
 */
export function instanceOfGetWellKnownEmailServices200ResponseInnerConfig(value: object): value is GetWellKnownEmailServices200ResponseInnerConfig {
    return true;
}

export function GetWellKnownEmailServices200ResponseInnerConfigFromJSON(json: any): GetWellKnownEmailServices200ResponseInnerConfig {
    return GetWellKnownEmailServices200ResponseInnerConfigFromJSONTyped(json, false);
}

export function GetWellKnownEmailServices200ResponseInnerConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetWellKnownEmailServices200ResponseInnerConfig {
    if (json == null) {
        return json;
    }
    return {
        
        'host': json['host'] == null ? undefined : json['host'],
        'port': json['port'] == null ? undefined : json['port'],
        'secure': json['secure'] == null ? undefined : json['secure'],
    };
}

export function GetWellKnownEmailServices200ResponseInnerConfigToJSON(json: any): GetWellKnownEmailServices200ResponseInnerConfig {
    return GetWellKnownEmailServices200ResponseInnerConfigToJSONTyped(json, false);
}

export function GetWellKnownEmailServices200ResponseInnerConfigToJSONTyped(value?: GetWellKnownEmailServices200ResponseInnerConfig | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'host': value['host'],
        'port': value['port'],
        'secure': value['secure'],
    };
}

